






















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ConfirmModal from "@/components/ConfirmModal.vue";
import OkModal from "@/components/OkModal.vue";
import SalonComponent from "@/components/SalonComponent.vue";
import { TicketUser } from "@/models/ticket_user";
import { Salon } from "@/models/salon";
import SystemConst from "@/config/const";
import moment from "moment";
import firebase from "firebase/app";
import "firebase/functions";
import "firebase/firestore";
const db = firebase.firestore();
import TicketFavoriteService from "@/services/TicketFavoriteService";
import PurchasedTicketService from "@/services/PurchasedTicketService";

@Component({
  name: "TicketUseApp",
  components: {
    ConfirmModal,
    OkModal,
    SalonComponent,
  },
})
export default class TicketUseApp extends Vue {
  ticketId = "";
  salonId = "";
  ticketUser: TicketUser = new TicketUser();
  SystemConst = SystemConst;
  isTicketUsed = false;
  cancelConfirmTitle = "";
  cancelConfirmMsg = "";
  errorTitle = "";
  errorMsg = "";
  isProcessing = false;
  title = "";
  ticketNumberStr = "";
  salon = {} as any;
  pTicket = {} as any;
  purchasedTicket = {} as any;
  isDisabledFav = false;
  faved = false;
  purchasedTicketId = "";
  useService = false;
  isSecretSale = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  openCancelConfirmModal() {
    if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_SUBSCRIPTION) {
      this.cancelConfirmTitle =
        "定額制(サブスク)サービスをキャンセルしますか？";
      this.cancelConfirmMsg =
        "・定額制(サブスク)サービスはキャンセルした日の月末で利用ができなくなります。\n・いかなる事由があろうとも、支払済みの金員について、当社は返金する義務を負いません。";
    } else {
      this.cancelConfirmTitle = "サービスをキャンセルしますか？";
      this.cancelConfirmMsg =
        "購入して14日の間でしたらサービスのキャンセルが可能です。サービスをキャンセルした場合は、クレジットカードの決済は行われません";
    }
    this.refs.cancelConfirmModal.open();
  }

  openUseConfirmModal() {
    this.refs.useConfirmModal.open();
  }

  async ticketCancel() {
    if (this.isProcessing) return;
    this.isProcessing = true;
    await PurchasedTicketService.cancelPurchasedTicket(this.purchasedTicket.id)
      .then((rsp: any) => {
        this.purchasedTicket = rsp.data.purchased_ticket;
      })
      .catch((err: any) => {
        this.errorTitle = "システムエラー";
        this.errorMsg = "後でもう一度やり直してください";
        this.refs.errorOKModal.open();
      });
    this.isProcessing = false;
  }

  async ticketUse() {
    if (this.isProcessing) return;
    this.isProcessing = true;
    await PurchasedTicketService.usePurchasedTicket(this.purchasedTicket.id)
      .then((rsp: any) => {
        this.purchasedTicket = rsp.data.purchased_ticket;
        this.useService = true;
      })
      .catch((err: any) => {
        this.errorTitle = "システムエラー";
        this.errorMsg = "後でもう一度やり直してください";
        this.refs.errorOKModal.open();
      });
    this.isProcessing = false;
  }

  public async created() {
    this.purchasedTicketId = this.$route.params.purchased_ticket_id;
    const {
      data: { purchased_ticket },
    } = await PurchasedTicketService.getPurchasedTicket(
      this.purchasedTicketId
    ).catch((err: any) => {
      return { data: { purchased_ticket: null } };
    });
    if (!purchased_ticket) {
      this.$router.push({ name: "NotFound" });
    }
    this.purchasedTicket = purchased_ticket;
    if (this.purchasedTicket.sale_method === SystemConst.PURCHASED_TICKET_SECRET_SALE){
      this.isSecretSale = true;
    }
    this.pTicket = purchased_ticket.ticket;
    this.salon = this.pTicket.salon;
    this.$store.dispatch("actionSetHeaderUrl", this.salon.image_logo_url);
    this.$store.dispatch("actionSetSalonName", this.salon.salon_name);
    this.$store.dispatch("actionSetSalonId", this.salon.salon_id);
    document.title =
      "サービス利用 | " +
      this.salon.salon_name +
      " | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "サービス利用 | " +
          this.salon.salon_name +
          " | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
    this.title = document.title;
  }

  get ticketType() {
    let val: any;
    if (this.purchasedTicket.type === SystemConst.TICKET_SERVICE_TYPE_MULTIPLE) {
      if (this.purchasedTicket.available_count > 1) {
        val = SystemConst.TICKET_SERVICE_TYPE_MULTIPLE;
      } else {
        val = SystemConst.TICKET_SERVICE_TYPE_ONEC;
      }
    } else {
      val = this.purchasedTicket.type;
    }
    return val;
  }

  get expirationDateText() {
    let val: string;
    if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_SUBSCRIPTION) {
      val = "毎月自動更新";
    } else {
      val = this.purchasedTicket.expiration_date
        ? moment(this.purchasedTicket.purchased_at)
            .add(this.purchasedTicket.expiration_date, "days")
            .format("YYYY年MM月DD日") +
          `(${this.purchasedTicket.expiration_date}日間)`
        : "";
    }
    return val;
  }

  get availableCountText() {
    let val: string;
    if (
      this.purchasedTicket.available_count == SystemConst.MAX_AVAILABLE_COUNT
    ) {
      val = "制限なし";
    } else {
      val = `${this.purchasedTicket.available_use_quantity}回`;
    }
    return val;
  }

  get ticketTypeText() {
    let val = "";
    if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_SUBSCRIPTION) {
      val = "定額(サブスク)サービス";
    } else if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_ONEC) {
      val = "単品サービス";
    } else if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_MULTIPLE) {
      val = "回数券サービス";
    }
    return val;
  }

  get isDisabledUse() {
    return (
      this.purchasedTicket.out_of_date ||
      this.purchasedTicket.available_use_quantity == 0 ||
      ( this.purchasedTicket.status === 'canceled' && this.ticketType !== SystemConst.TICKET_SERVICE_TYPE_SUBSCRIPTION ) || this.useService
    );
  }

  async fav() {
    if (this.isDisabledFav) return;
    this.isDisabledFav = true;
    await TicketFavoriteService.createTicket({
      ticket_id: this.pTicket.id,
    }).then((rsp: any) => (this.faved = true));
    this.isDisabledFav = false;
  }

  async unFav() {
    if (this.isDisabledFav) return;
    this.isDisabledFav = true;
    this.faved = false;
    await TicketFavoriteService.deleteTicket(this.pTicket.id).then(
      (rsp: any) => (this.faved = false)
    );
    this.isDisabledFav = false;
  }

  async favedStatus() {
    const {
      data: { ticket_favorite },
    } = await TicketFavoriteService.getTicket(this.pTicket.id);
    this.faved = !!ticket_favorite;
  }

  @Watch("pTicket", { deep: true })
  onPTicketChanged() {
    if (this.pTicket.ticketId != "") {
      this.favedStatus();
    }
  }
}
